import React from 'react';
import { useLanguage } from '../../../../i18n/LanguageProvider';
import { SectionHeading, SliderButton } from '../../../../ui';

export function LandingServices() {
  const { language } = useLanguage();

  return (
    <div className="services-scroll-track" id="services-scroll-track">
      <section className="section section--services content-width" id="services" data-figma-node="125:48217" aria-labelledby="services-title">
        <SectionHeading
          title="Какие перевозки можно заказать"
          description="Просто выберите формат — заявка уйдёт в общую ленту, перевозчики нужного типа сами откликнутся со своими условиями"
          titleId="services-title"
        />
        <div className="services-stage" id="services-stage"></div>
        <div className="services-slider-controls" aria-label={language === 'en' ? 'Transport types' : 'Виды перевозок'}>
          <SliderButton direction="left" state="Default" className="services-slider-arrow" data-service-direction="previous" aria-label={language === 'en' ? 'Previous slide' : 'Предыдущий слайд'} />
          <div className="services-slider-dots">
            {Array.from({ length: 4 }, (_, index) => (
              <button
                className="services-slider-dot"
                type="button"
                data-service-slide={index}
                aria-label={language === 'en' ? `Slide ${index + 1} of 4` : `Слайд ${index + 1} из 4`}
                aria-current={index === 0 ? 'true' : undefined}
                key={index}
              />
            ))}
          </div>
          <SliderButton direction="right" state="Default" className="services-slider-arrow" data-service-direction="next" aria-label={language === 'en' ? 'Next slide' : 'Следующий слайд'} />
        </div>
      </section>
    </div>
  );
}
